import { Card } from "../ui/Card.jsx";
import { IconTile } from "../ui/IconTile.jsx";
import { SectionHeading } from "../ui/SectionHeading.jsx";
import { Pill } from "../ui/Pill.jsx";
import { Icon } from "../ui/Icon.jsx";

export function HowItWorks() {
  const loop = ["research", "formulate", "build & act", "observe"];

  return (
    <section className="section section-bg2" id="how">
      <div className="container">
        <SectionHeading eyebrow="How it works" title="Two systems. One loop." />
        <div className="how-grid">
          <Card className="how-card" data-reveal>
            <IconTile icon={<Icon.Brain />} size="lg" />
            <h3>Cognition — the understanding</h3>
            <p>
              A continuously updated model of your business: what you sell, what you've delivered,
              who your customers are, and what they respond to.
            </p>
          </Card>
          <Card className="how-card" data-reveal>
            <IconTile icon={<Icon.Gear />} size="lg" />
            <h3>Motor — the build &amp; the doing</h3>
            <p>
              The software that acts on that understanding — built and run for your business, not
              a generic template bolted on top of it.
            </p>
          </Card>
        </div>
        <div className="loop-row" data-reveal>
          {loop.map((step, i) => (
            <React.Fragment key={step}>
              <Pill index={i + 1} label={step} />
              {i < loop.length - 1 && <span className="loop-arrow">→</span>}
            </React.Fragment>
          ))}
          <span className="loop-arrow">↻</span>
        </div>
      </div>
    </section>
  );
}
